// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { UserProfile } from '../models/user-profile.model';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
	providedIn: 'root'
})
export class UserProfileService {

	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

	public updateUserProfile(userProfile: UserProfile): Observable<UserProfile> {
		return this.http.put<UserProfile>(`${this.appConfigService.getConfig().webApi}/api2/LexbeUserProfiles/${userProfile.userId}`, userProfile)
			.pipe(catchError(this.errorHandler.handleError<UserProfile>(`getUserProfile with id=${userProfile.userId}`)));
	}

	public getUserProfile(id: string): Observable<UserProfile> {
		return this.http.get<UserProfile>(`${this.appConfigService.getConfig().webApi}/api2/LexbeUserProfiles/${id}`)
			.pipe(catchError(this.errorHandler.handleError<UserProfile>(`getUserProfile with id=${id}`)));
	}

	public isUserProfileComplete(id: string): Observable<boolean> {
		return this.getUserProfile(id).pipe(
			map(userProfile => !this.isNullOrSpaces(userProfile.firstName)
							&& !this.isNullOrSpaces(userProfile.lastName)));
	}

	private isNullOrSpaces(s: string): boolean {
		return s === null || s.match(/^ *$/) !== null;
	}
}
